import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_user = (id) => {
  // 后端使用 DELETE 方法，参数在 requestBody 的 JSON 中
  return api.delete(ApiEndpointConstants.DELETE_USER, {
    data: { id }
  });
};
